import React from "react";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";

import { Tooltip } from "antd";

const KMKGroupSelect = ({
  options,
  label,
  value,
  handleChange,
  selectedGroup,
  handleOptionSelect,
  tooltip = true,
  required = false,
  error = false,
  errorText = "",
  helperText = "",
  onOpen = () => {},
  loading = false,
  ...props
}) => {
  // If no error and value is not empty and tooltip is passed true then only show tooltip
  return tooltip && !error && value.groupBy && value.title ? (
    <Tooltip
      placement="bottom"
      color="#28231D"
      overlayStyle={{ maxWidth: "350px" }}
      title={`${value.groupBy} • ${value.title}`}
    >
      <Autocomplete
        onOpen={onOpen}
        loading={loading}
        id="grouped-auto-complete"
        options={options}
        groupBy={(option) => option.groupBy}
        getOptionLabel={(option) => option.title}
        value={value}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            helperText={error ? errorText : helperText}
            error={error}
            required={required}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        isOptionEqualToValue={(option, value) => {
          return (
            option.title.toLowerCase() === value.title.toLowerCase() &&
            option.groupBy.toLowerCase() === value.groupBy.toLowerCase()
          );
        }}
        onChange={(e, value) => handleChange(e, value)}
        slotProps={{ paper: { style: { marginBottom: "8px" } } }}
        {...props}
      />
    </Tooltip>
  ) : (
    <Autocomplete
      onOpen={onOpen}
      loading={loading}
      id="grouped-auto-complete"
      options={options}
      groupBy={(option) => option.groupBy}
      getOptionLabel={(option) => option.title}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          helperText={error ? errorText : helperText}
          error={error}
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      isOptionEqualToValue={(option, value) => {
        return (
          option.title.toLowerCase() === value.title.toLowerCase() &&
          option.groupBy.toLowerCase() === value.groupBy.toLowerCase()
        );
      }}
      onChange={(e, value) => handleChange(e, value)}
      slotProps={{ paper: { style: { marginBottom: "8px" } } }}
      {...props}
    />
  );
};

export default React.memo(KMKGroupSelect);
